import { SECRET_MASK } from "../constants";
import {
  healthCheckReadProbeCollections,
  healthTestCollectionName,
} from "./healthTestCollectionUtils";

export const FIREBASE_SDK_VERSION = "12.11.0";
export const VERIFY_TIMEOUT_MS = 15_000;
export const HEALTH_COLLECTIONS = healthCheckReadProbeCollections();

export const OPTIONAL_SERVICES = [
  "functions", "hosting", "appCheck", "analytics", "messaging", "crashlytics",
];

export const IGNORABLE_STATUSES = ["not_configured", "skipped", "not_enabled", "not_signed_in"];

export const CONFIG_FIELDS = [
  { key: "apiKey", label: "API Key", required: true },
  { key: "authDomain", label: "Auth Domain", required: true },
  { key: "firebaseProjectId", label: "Project ID", required: true },
  { key: "appId", label: "App ID", required: true },
  { key: "storageBucket", label: "Storage Bucket", required: false },
  { key: "messagingSenderId", label: "Messaging Sender ID", required: false },
  { key: "measurementId", label: "Measurement ID", required: false },
  { key: "region", label: "Functions Region", required: false },
];

export const PROBE_COLLECTIONS = [
  healthTestCollectionName(),
  "studio_health",
  "studio_projects",
  "studio_connections",
  "studio_users",
  "users",
];

export const INDEX_RECOMMENDATIONS = [
  { collection: "studio_cloud_jobs", fields: ["queue", "createdAt"], reason: "Worker queue filtering" },
  { collection: "studio_cloud_logs", fields: ["source", "createdAt"], reason: "Log source filter" },
  {
    collection: healthTestCollectionName(),
    fields: ["createdAt"],
    reason: "Health check ordering",
  },
];

export function nowIso() {
  return new Date().toISOString();
}

export function detectBrowser() {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("Chrome/")) return "Chrome";
  if (ua.includes("Firefox/")) return "Firefox";
  if (ua.includes("Safari/")) return "Safari";
  return "Browser";
}

export function detectOs() {
  if (typeof navigator === "undefined") return "unknown";
  const ua = navigator.userAgent || "";
  if (ua.includes("Windows")) return "Windows";
  if (ua.includes("Mac OS")) return "macOS";
  if (ua.includes("Linux")) return "Linux";
  if (ua.includes("Android")) return "Android";
  if (ua.includes("iPhone") || ua.includes("iPad")) return "iOS";
  return navigator.platform || "unknown";
}

export function withTimeout(promise, ms, label) {
  return Promise.race([
    promise,
    new Promise((_, reject) => {
      setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
    }),
  ]);
}

export function buildFirebaseConfig(conn) {
  return {
    apiKey: conn.apiKey,
    authDomain: conn.authDomain,
    projectId: conn.firebaseProjectId,
    storageBucket: conn.storageBucket || undefined,
    messagingSenderId: conn.messagingSenderId || undefined,
    appId: conn.appId,
    measurementId: conn.measurementId || undefined,
  };
}

export function makeServiceResult(status, message, latencyMs = 0, extra = {}) {
  return { status, message, latencyMs, ...extra };
}

export function pushCheck(checks, service, result) {
  checks.push({
    service,
    status: result.status,
    message: result.message,
    latencyMs: result.latencyMs ?? 0,
    ...(result.code ? { code: result.code } : {}),
  });
  return result;
}

export function isMaskedOrEmpty(value) {
  const v = String(value || "").trim();
  return !v || v === SECRET_MASK;
}
